/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ref_N4Inputs */

const en_csv_to_json_ref_n4 = /** @type {(inputs: Csv_To_Json_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A numeric looking field stays a string, so the leading zero survives.`)
};

const ko_csv_to_json_ref_n4 = /** @type {(inputs: Csv_To_Json_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숫자처럼 보이는 필드도 문자열로 남으므로 앞의 0이 살아남습니다.`)
};

const ja_csv_to_json_ref_n4 = /** @type {(inputs: Csv_To_Json_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値に見えるフィールドも文字列のままなので、先頭のゼロが残ります。`)
};

/**
* | output |
* | --- |
* | "A numeric looking field stays a string, so the leading zero survives." |
*
* @param {Csv_To_Json_Ref_N4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ref_n4 = /** @type {((inputs?: Csv_To_Json_Ref_N4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ref_N4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ref_n4(inputs)
	if (locale === "ko") return ko_csv_to_json_ref_n4(inputs)
	return ja_csv_to_json_ref_n4(inputs)
});